export enum AppActions {
    INIT_STORE = 'PRE-FIBER/APP/initStore',
    SET_LOADING = 'PRE-FIBER/APP/setLoading',
    SET_VALIDITY = 'PRE-FIBER/APP/setValidity',
    SET_ADDRESS = 'PRE-FIBER/APP/setAddress',
    DELETE_ADDRESS = 'PRE-FIBER/APP/deleteAddress',
    SET_ERROR = 'PRE-FIBER/APP/setError',
    SET_TARIFFS = 'PRE-FIBER/APP/setTariffs',
    SET_SELECTED_TARIFF_ID = 'PRE-FIBER/APP/setSelectedTariffId',
    SET_AVC_RESULT = 'PRE-FIBER/APP/setAvcResult',
    TRIGGER_REDIRECT = 'PRE-FIBER/APP/triggerRedirect',
    SET_OVERLAY_LOADED = 'PRE-FIBER/APP/setOverlayLoaded',
    OPEN_OVERLAY = 'PRE-FIBER/APP/openOverlay',
    CLOSE_OVERLAY = 'PRE-FIBER/APP/closeOverlay',
    SET_ACTIVE_OVERLAY = 'PRE-FIBER/APP/setActiveOverlay',
    RESET_TARIFFS_TO_PRE_AVC = 'PRE-FIBER/APP/resetTariffsToPreAvc',
    SET_HOMES_PASSED = 'PRE-FIBER/APP/setHomesPassed',
}

export enum OverlayError {
    CONFIG_MISSING_AVC = 'AVC config object not found',
    CONFIG_MISSING_LM = 'LM config object not found',
    OVERLAY_MISSING = 'Overlay object not found'
}

export enum FormType {
    ADDRESS = 'address',
};
